import styled from 'styled-components'

import { useAppRoutes } from '@root/features/routing'
import { Close6Icon } from '@root/shared/ui-kit'

import type { PairActivity } from '../model'
import type { PropsWithChildren } from 'react'

type Props = {
  onClose?: () => void
  activity: PairActivity.ActivityBase
} & PropsWithChildren

export const PairActivitySnackbarBase = ({
  onClose,
  children,
  activity,
}: Props) => {
  const { navigateToTrading } = useAppRoutes()

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    e.stopPropagation()
    onClose?.()
  }

  return (
    <Root
      onClick={() => {
        navigateToTrading(activity.address, activity.network)
      }}
    >
      {children}
      {onClose ? (
        <Close type="button" onClick={handleClose}>
          <Close6Icon size={14} />
        </Close>
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  background: var(--backgroundA-3);

  border-radius: 12px;
  border: 0.5px solid rgba(255, 255, 255, 0.21);
  box-shadow: 0 6px 18px 0 var(--appearanceA-2);
  backdrop-filter: blur(21px);

  padding: 10px;
  flex-shrink: 0;
  margin-bottom: 5px;
  gap: 8px;
  cursor: pointer;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  pointer-events: all;
  place-self: center;
`

const Close = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  place-items: center;

  svg {
    color: var(--textA-9);

    transition: all 0.15s ease-in-out;

    &:hover {
      color: var(--text-12);
    }
  }
`
